import accountPage from 'components/woocommerce/account/index';


accountPage();
